import React from 'react'

const Component4 = () => {
  return (
    <div>Component4</div>
  )
}

export default Component4